import { render, staticRenderFns } from "./CopyrightAssignmentTransferTaskQueue.vue?vue&type=template&id=f1921aca&scoped=true&"
import script from "./CopyrightAssignmentTransferTaskQueue.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferTaskQueue.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferTaskQueue.vue?vue&type=style&index=0&id=f1921aca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1921aca",
  null
  
)

export default component.exports